import { Environment, eul10n, l10n } from './shared.models';

export const environment: Environment = {
  production: false,
  devTools: true,
  hmr: false,
  name: 'staging',
  authEnv: 'staging',
  appUrl: 'https://maps.staging.vdo-fleet.com',
  useSettingsApi: false,
  datadog: {
    applicationId: '376213ad-4a16-4ec0-9af4-43bfaf54fbc1',
    clientToken: 'pub07dd18e3a77864f9153835ece3c3c745',
    tagEnvironment: 'tm-staging'
  },
  devCycle: {
    clientId: 'dvc_client_e8ef5d35_67d5_4dee_b4df_4ec19647dc37_a541b13'
  },
  here: {
    apiKeyV3: 'L9xQLvUWGuArXYtky8qlYqb5dMCHoGhPoBDfQFqh_QY'
  },
  auth: {
    clientID: 'iiDLR0NkJemifWqWueOxzUxlXtW6csqh',
    domain: 'login.auth.staging.vdo-fleet.com',
    audience: 'https://api.fleet.vdo.com',
    // audience: 'https://api.qa.continental-mobility-services.com',
    applicationId: 'fb8e38e1-9403-444e-aa6c-046b33ccab3c',
    useRefreshTokens: true,
    maxAge: 36000
  },
  locationApi: {
    // url: 'https://location-api.qa.eu.zonarsystems.net/api/v1beta2',
    // url: 'http://localhost:8251/location/api/v1beta2',
    url: 'https://www.at.my-fis.com/dmm50/edge-server/historical-asset-service/api/v1',
    hasAssociatedDevice: true
  },
  pathApiBase: {
    // url: 'https://api.qa.continental-mobility-services.com/core/v1'
    // url: 'http://localhost:8251/api/v1beta2'
    url: 'https://www.at.my-fis.com/dmm50/edge-server/historical-asset-service/api/v1'
  },
  geocoderApiBase: {
    url: 'https://www.at.my-fis.com/dmm50/edge-server/geocoder-service/api/v1'
    // ${environment.vdofleet.baseApiUrl}/geocoder-service/api/v1/reverse
  },
  pathApiRequestPageSize: 2000,
  dataUpdateMessages: {
    // units are minutes
    updateInterval: 1,
    idling: 60 * 12,
    notIdling: 15
  },
  nearbyAssets: {
    searchRadiusMeters: 50 * 1609, // 50 miles in meters
    assetsToReturn: 10,
    searchRadiusInKm: 80, // 80 km
    searchRadiusInMiles: 50 // 50 miles
  },
  liveUpdate: {
    pageSize: 150,
    concurrency: 7,
    pollingInterval: 10_000,
    consecutiveFailureLimit: 3,
    restartPollingDelay: 30_000
  },
  // zTrakBatteryAlertPct: 0.1,
  apiRequestPageSize: 500,
  datadogSite: 'datadoghq.eu',
  minimumTripMS: 60000,
  featureFlags: {
    assetIOs: true
  },
  region: 'EU',
  vdofleet: {
    baseApiUrl: 'https://www.at.my-fis.com/dmm50/edge-server',
    baseApiAudience: 'https://api.fleet.vdo.com'
  },
  // gtcxUrl: { can add gtcx urls in the future if they go to EU },
  euUrl: {
    vdoDashboardUrl: 'https://www.at.my-fis.com/dmm50/app/',
    vdoReportsUrl: 'https://www.at.my-fis.com/dmm50/app/reports/',
    geofencingUrl: 'https://www.at.my-fis.com/dmm50/app/geofencing/'
  },
  i18n: {
    supportedLanguages: [
      'en-US',
      'de-DE',
      'en-GB',
      'es-ES',
      'fr-FR',
      'it-IT',
      'bg-BG',
      'cs-CZ',
      'el-GR',
      'lt-LT',
      'pl-PL',
      'pt-PT',
      'ro-RO',
      'hr-HR',
      'sk-SK',
      'sl-SI',
      'mk-MK',
      'et-EE',
      'nb-NO',
      'nl-NL'
    ],
    defaultLanguage: 'en-GB'
  },
  l10n: eul10n,
  hamburgerMenuEnabled: false
  // legacyAccountsEnabled: false
};
